import request from '@/config/request'
import { bandCar, getOrderReport, openId } from './interface'

export const bandCarInfo = (data: bandCar) =>
    request({
        url: '/wxgzh/bindTruck',
        method: 'post',
        data
    })

export const orderReport = (data: getOrderReport) =>
    request({
        url: '/wxgzh/wxrReport',
        method: 'post',
        data
    })

export const getFacList = () =>
request({
    url: '/wxgzh/facList',
    method: 'post'
})
